"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMNSignalIntermediateThrowEvent = exports.BPMNSignalIntermediateCatchEvent = exports.BPMNCompensateIntermediateThrowEvent = exports.BPMNLinkIntermediateThrowEvent = exports.BPMNConditionalIntermediateThrowEvent = exports.BPMNEscalationIntermediateThrowEvent = exports.BPMNTimerIntermediateCatchEvent = exports.BPMNMessageIntermediateThrowEvent = exports.BPMNMessageIntermediateCatchEvent = exports.BPMNIntermediateCatchEvent = exports.BPMNIntermediateThrowEvent = exports.BPMNCondition = exports.BPMNConditionExpression = exports.BPMNSubProcess = exports.BPMNParallelGateway = exports.BPMNInclusiveExclusiveGateway = exports.BPMNEndEvent = exports.BPMNCallActivity = exports.BPMNScriptTask = exports.BPMNServiceTask = exports.BPMNBusinessRuleTask = exports.BPMNManualTask = exports.BPMNReceiveTask = exports.BPMNsendTask = exports.BPMNTask = exports.BPMNUserTask = exports.BPMNGenericTask = exports.BPMNSequenceFlow = exports.BPMNIncoming = exports.BPMNOutgoing = exports.BPMNStartEvent = exports.BPMNProcess = void 0;
var BPMNEntity_1 = require("./BPMNEntity");
var EntitiesHelper_1 = require("../../helpers/EntitiesHelper");
var BPMNProcess = (function (_super) {
    __extends(BPMNProcess, _super);
    function BPMNProcess(id, processName, isExecutable) {
        if (isExecutable === void 0) { isExecutable = 'true'; }
        return _super.call(this, 'bpmn:process', undefined, { id: id, name: processName, isExecutable: isExecutable }) || this;
    }
    return BPMNProcess;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNProcess = BPMNProcess;
var BPMNStartEvent = (function (_super) {
    __extends(BPMNStartEvent, _super);
    function BPMNStartEvent(id, outgoingIds) {
        var _this = _super.call(this, 'bpmn:startEvent', undefined, { id: id }) || this;
        if (outgoingIds !== undefined) {
            for (var _i = 0, _a = EntitiesHelper_1.EntHelper.StrToStrArray(outgoingIds); _i < _a.length; _i++) {
                var out = _a[_i];
                _this.addChild(new BPMNOutgoing(out));
            }
        }
        return _this;
    }
    return BPMNStartEvent;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNStartEvent = BPMNStartEvent;
var BPMNOutgoing = (function (_super) {
    __extends(BPMNOutgoing, _super);
    function BPMNOutgoing(value) {
        return _super.call(this, 'bpmn:outgoing', value) || this;
    }
    return BPMNOutgoing;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNOutgoing = BPMNOutgoing;
var BPMNIncoming = (function (_super) {
    __extends(BPMNIncoming, _super);
    function BPMNIncoming(value) {
        return _super.call(this, 'bpmn:incoming', value) || this;
    }
    return BPMNIncoming;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNIncoming = BPMNIncoming;
var BPMNSequenceFlow = (function (_super) {
    __extends(BPMNSequenceFlow, _super);
    function BPMNSequenceFlow(id, sourceRef, targetRef, condition) {
        var _this = _super.call(this, 'bpmn:sequenceFlow', undefined, { id: id, sourceRef: sourceRef, targetRef: targetRef }) || this;
        if (condition !== undefined)
            _this.addChild(condition);
        return _this;
    }
    return BPMNSequenceFlow;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNSequenceFlow = BPMNSequenceFlow;
var BPMNGenericTask = (function (_super) {
    __extends(BPMNGenericTask, _super);
    function BPMNGenericTask(taskType, id, taskName, incomingIds, outgoingIds) {
        var _this = _super.call(this, taskType, undefined, { id: id }) || this;
        if (incomingIds !== undefined) {
            for (var _i = 0, _a = EntitiesHelper_1.EntHelper.StrToStrArray(incomingIds); _i < _a.length; _i++) {
                var inc = _a[_i];
                _this.addChild(new BPMNIncoming(inc));
            }
        }
        if (outgoingIds !== undefined) {
            for (var _b = 0, _c = EntitiesHelper_1.EntHelper.StrToStrArray(outgoingIds); _b < _c.length; _b++) {
                var out = _c[_b];
                _this.addChild(new BPMNOutgoing(out));
            }
        }
        if (taskName !== undefined) {
            _this.setAttribute('name', taskName);
        }
        return _this;
    }
    return BPMNGenericTask;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNGenericTask = BPMNGenericTask;
var BPMNUserTask = (function (_super) {
    __extends(BPMNUserTask, _super);
    function BPMNUserTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:userTask', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNUserTask;
}(BPMNGenericTask));
exports.BPMNUserTask = BPMNUserTask;
var BPMNTask = (function (_super) {
    __extends(BPMNTask, _super);
    function BPMNTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:task', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNTask;
}(BPMNGenericTask));
exports.BPMNTask = BPMNTask;
var BPMNsendTask = (function (_super) {
    __extends(BPMNsendTask, _super);
    function BPMNsendTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:sendTask', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNsendTask;
}(BPMNGenericTask));
exports.BPMNsendTask = BPMNsendTask;
var BPMNReceiveTask = (function (_super) {
    __extends(BPMNReceiveTask, _super);
    function BPMNReceiveTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:receiveTask', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNReceiveTask;
}(BPMNGenericTask));
exports.BPMNReceiveTask = BPMNReceiveTask;
var BPMNManualTask = (function (_super) {
    __extends(BPMNManualTask, _super);
    function BPMNManualTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:manualTask', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNManualTask;
}(BPMNGenericTask));
exports.BPMNManualTask = BPMNManualTask;
var BPMNBusinessRuleTask = (function (_super) {
    __extends(BPMNBusinessRuleTask, _super);
    function BPMNBusinessRuleTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:businessRuleTask', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNBusinessRuleTask;
}(BPMNGenericTask));
exports.BPMNBusinessRuleTask = BPMNBusinessRuleTask;
var BPMNServiceTask = (function (_super) {
    __extends(BPMNServiceTask, _super);
    function BPMNServiceTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:serviceTask', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNServiceTask;
}(BPMNGenericTask));
exports.BPMNServiceTask = BPMNServiceTask;
var BPMNScriptTask = (function (_super) {
    __extends(BPMNScriptTask, _super);
    function BPMNScriptTask(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:scriptTask', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNScriptTask;
}(BPMNGenericTask));
exports.BPMNScriptTask = BPMNScriptTask;
var BPMNCallActivity = (function (_super) {
    __extends(BPMNCallActivity, _super);
    function BPMNCallActivity(id, taskName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:callActivity', id, taskName, incomingIds, outgoingIds) || this;
    }
    return BPMNCallActivity;
}(BPMNGenericTask));
exports.BPMNCallActivity = BPMNCallActivity;
var BPMNEndEvent = (function (_super) {
    __extends(BPMNEndEvent, _super);
    function BPMNEndEvent(id, incomingIds) {
        var _this = _super.call(this, 'bpmn:endEvent', undefined, { id: id }) || this;
        if (incomingIds !== undefined) {
            for (var _i = 0, _a = EntitiesHelper_1.EntHelper.StrToStrArray(incomingIds); _i < _a.length; _i++) {
                var inc = _a[_i];
                _this.addChild(new BPMNIncoming(inc));
            }
        }
        return _this;
    }
    return BPMNEndEvent;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNEndEvent = BPMNEndEvent;
var BPMNInclusiveExclusiveGateway = (function (_super) {
    __extends(BPMNInclusiveExclusiveGateway, _super);
    function BPMNInclusiveExclusiveGateway(type, id, incomingIds, outgoingIds) {
        return _super.call(this, type == 'exc' ? 'bpmn:exclusiveGateway' : 'bpmn:inclusiveGateway', id, undefined, incomingIds, outgoingIds) || this;
    }
    return BPMNInclusiveExclusiveGateway;
}(BPMNGenericTask));
exports.BPMNInclusiveExclusiveGateway = BPMNInclusiveExclusiveGateway;
var BPMNParallelGateway = (function (_super) {
    __extends(BPMNParallelGateway, _super);
    function BPMNParallelGateway(id, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:parallelGateway', id, undefined, incomingIds, outgoingIds) || this;
    }
    return BPMNParallelGateway;
}(BPMNGenericTask));
exports.BPMNParallelGateway = BPMNParallelGateway;
var BPMNSubProcess = (function (_super) {
    __extends(BPMNSubProcess, _super);
    function BPMNSubProcess(id, subprocessName, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:subProcess', id, subprocessName, incomingIds, outgoingIds) || this;
    }
    return BPMNSubProcess;
}(BPMNGenericTask));
exports.BPMNSubProcess = BPMNSubProcess;
var BPMNConditionExpression = (function (_super) {
    __extends(BPMNConditionExpression, _super);
    function BPMNConditionExpression(expression, type) {
        if (type === void 0) { type = 'bpmn:tFormalExpression'; }
        return _super.call(this, 'bpmn:conditionExpression', expression, { 'xsi:type': type }) || this;
    }
    return BPMNConditionExpression;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNConditionExpression = BPMNConditionExpression;
var BPMNCondition = (function (_super) {
    __extends(BPMNCondition, _super);
    function BPMNCondition(expression, type) {
        if (type === void 0) { type = 'bpmn:tFormalExpression'; }
        return _super.call(this, 'bpmn:condition', expression, { 'xsi:type': type }) || this;
    }
    return BPMNCondition;
}(BPMNEntity_1.BPMNEntity));
exports.BPMNCondition = BPMNCondition;
var BPMNIntermediateThrowEvent = (function (_super) {
    __extends(BPMNIntermediateThrowEvent, _super);
    function BPMNIntermediateThrowEvent(id, name, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:intermediateThrowEvent', id, name, incomingIds, outgoingIds) || this;
    }
    return BPMNIntermediateThrowEvent;
}(BPMNGenericTask));
exports.BPMNIntermediateThrowEvent = BPMNIntermediateThrowEvent;
var BPMNIntermediateCatchEvent = (function (_super) {
    __extends(BPMNIntermediateCatchEvent, _super);
    function BPMNIntermediateCatchEvent(id, name, incomingIds, outgoingIds) {
        return _super.call(this, 'bpmn:intermediateCatchEvent', id, name, incomingIds, outgoingIds) || this;
    }
    return BPMNIntermediateCatchEvent;
}(BPMNGenericTask));
exports.BPMNIntermediateCatchEvent = BPMNIntermediateCatchEvent;
var BPMNMessageEventDefinition = (function (_super) {
    __extends(BPMNMessageEventDefinition, _super);
    function BPMNMessageEventDefinition(id) {
        return _super.call(this, 'bpmn:messageEventDefinition', undefined, { id: id }) || this;
    }
    return BPMNMessageEventDefinition;
}(BPMNEntity_1.BPMNEntity));
var BPMNMessageIntermediateCatchEvent = (function (_super) {
    __extends(BPMNMessageIntermediateCatchEvent, _super);
    function BPMNMessageIntermediateCatchEvent(id, name, messageEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNMessageEventDefinition(messageEventDefinitionId));
        return _this;
    }
    return BPMNMessageIntermediateCatchEvent;
}(BPMNIntermediateCatchEvent));
exports.BPMNMessageIntermediateCatchEvent = BPMNMessageIntermediateCatchEvent;
var BPMNMessageIntermediateThrowEvent = (function (_super) {
    __extends(BPMNMessageIntermediateThrowEvent, _super);
    function BPMNMessageIntermediateThrowEvent(id, name, messageEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNMessageEventDefinition(messageEventDefinitionId));
        return _this;
    }
    return BPMNMessageIntermediateThrowEvent;
}(BPMNIntermediateThrowEvent));
exports.BPMNMessageIntermediateThrowEvent = BPMNMessageIntermediateThrowEvent;
var BPMNTimerEventDefinition = (function (_super) {
    __extends(BPMNTimerEventDefinition, _super);
    function BPMNTimerEventDefinition(id) {
        return _super.call(this, 'bpmn:timerEventDefinition', undefined, { id: id }) || this;
    }
    return BPMNTimerEventDefinition;
}(BPMNEntity_1.BPMNEntity));
var BPMNTimerIntermediateCatchEvent = (function (_super) {
    __extends(BPMNTimerIntermediateCatchEvent, _super);
    function BPMNTimerIntermediateCatchEvent(id, name, timerEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNTimerEventDefinition(timerEventDefinitionId));
        return _this;
    }
    return BPMNTimerIntermediateCatchEvent;
}(BPMNIntermediateCatchEvent));
exports.BPMNTimerIntermediateCatchEvent = BPMNTimerIntermediateCatchEvent;
var BPMNEscalationEventDefinition = (function (_super) {
    __extends(BPMNEscalationEventDefinition, _super);
    function BPMNEscalationEventDefinition(id) {
        return _super.call(this, 'bpmn:escalationEventDefinition', undefined, { id: id }) || this;
    }
    return BPMNEscalationEventDefinition;
}(BPMNEntity_1.BPMNEntity));
var BPMNEscalationIntermediateThrowEvent = (function (_super) {
    __extends(BPMNEscalationIntermediateThrowEvent, _super);
    function BPMNEscalationIntermediateThrowEvent(id, name, escalationEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNEscalationEventDefinition(escalationEventDefinitionId));
        return _this;
    }
    return BPMNEscalationIntermediateThrowEvent;
}(BPMNIntermediateCatchEvent));
exports.BPMNEscalationIntermediateThrowEvent = BPMNEscalationIntermediateThrowEvent;
var BPMNConditionalEventDefinition = (function (_super) {
    __extends(BPMNConditionalEventDefinition, _super);
    function BPMNConditionalEventDefinition(id, condition) {
        var _this = _super.call(this, 'bpmn:conditionalEventDefinition', undefined, { id: id }) || this;
        _this.addChild(new BPMNCondition(condition));
        return _this;
    }
    return BPMNConditionalEventDefinition;
}(BPMNEntity_1.BPMNEntity));
var BPMNConditionalIntermediateThrowEvent = (function (_super) {
    __extends(BPMNConditionalIntermediateThrowEvent, _super);
    function BPMNConditionalIntermediateThrowEvent(id, name, conditionalEventDefinitionId, condition, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNConditionalEventDefinition(conditionalEventDefinitionId, condition));
        return _this;
    }
    return BPMNConditionalIntermediateThrowEvent;
}(BPMNIntermediateThrowEvent));
exports.BPMNConditionalIntermediateThrowEvent = BPMNConditionalIntermediateThrowEvent;
var BPMNLinkEventDefinition = (function (_super) {
    __extends(BPMNLinkEventDefinition, _super);
    function BPMNLinkEventDefinition(id) {
        return _super.call(this, 'bpmn:linkEventDefinition', undefined, { id: id }) || this;
    }
    return BPMNLinkEventDefinition;
}(BPMNEntity_1.BPMNEntity));
var BPMNLinkIntermediateThrowEvent = (function (_super) {
    __extends(BPMNLinkIntermediateThrowEvent, _super);
    function BPMNLinkIntermediateThrowEvent(id, name, linkEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNLinkEventDefinition(linkEventDefinitionId));
        return _this;
    }
    return BPMNLinkIntermediateThrowEvent;
}(BPMNIntermediateThrowEvent));
exports.BPMNLinkIntermediateThrowEvent = BPMNLinkIntermediateThrowEvent;
var BPMNCompensateEventDefinition = (function (_super) {
    __extends(BPMNCompensateEventDefinition, _super);
    function BPMNCompensateEventDefinition(id) {
        return _super.call(this, 'bpmn:compensateEventDefinition', undefined, { id: id }) || this;
    }
    return BPMNCompensateEventDefinition;
}(BPMNEntity_1.BPMNEntity));
var BPMNCompensateIntermediateThrowEvent = (function (_super) {
    __extends(BPMNCompensateIntermediateThrowEvent, _super);
    function BPMNCompensateIntermediateThrowEvent(id, name, compensateEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNCompensateEventDefinition(compensateEventDefinitionId));
        return _this;
    }
    return BPMNCompensateIntermediateThrowEvent;
}(BPMNIntermediateThrowEvent));
exports.BPMNCompensateIntermediateThrowEvent = BPMNCompensateIntermediateThrowEvent;
var BPMNSignalEventDefinition = (function (_super) {
    __extends(BPMNSignalEventDefinition, _super);
    function BPMNSignalEventDefinition(id) {
        return _super.call(this, 'bpmn:signalEventDefinition', undefined, { id: id }) || this;
    }
    return BPMNSignalEventDefinition;
}(BPMNEntity_1.BPMNEntity));
var BPMNSignalIntermediateCatchEvent = (function (_super) {
    __extends(BPMNSignalIntermediateCatchEvent, _super);
    function BPMNSignalIntermediateCatchEvent(id, name, signalEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNSignalEventDefinition(signalEventDefinitionId));
        return _this;
    }
    return BPMNSignalIntermediateCatchEvent;
}(BPMNIntermediateCatchEvent));
exports.BPMNSignalIntermediateCatchEvent = BPMNSignalIntermediateCatchEvent;
var BPMNSignalIntermediateThrowEvent = (function (_super) {
    __extends(BPMNSignalIntermediateThrowEvent, _super);
    function BPMNSignalIntermediateThrowEvent(id, name, signalEventDefinitionId, incomingIds, outgoingIds) {
        var _this = _super.call(this, id, name, incomingIds, outgoingIds) || this;
        _this.addChild(new BPMNSignalEventDefinition(signalEventDefinitionId));
        return _this;
    }
    return BPMNSignalIntermediateThrowEvent;
}(BPMNIntermediateThrowEvent));
exports.BPMNSignalIntermediateThrowEvent = BPMNSignalIntermediateThrowEvent;
//# sourceMappingURL=BPMNElements.js.map